import { compose, prop } from 'ramda';

import { NAME } from './constants';

export const getRoot = prop(NAME);

export const getRadio = compose(prop('radio'), getRoot);
export const getGuarantors = compose(prop('guarantors'), getRoot);
export const getGuarantorsOfRegion = compose(prop('guarantorsOfRegion'), getRoot);
export const getSelectedGuarantors = compose(prop('selectedGuarantors'), getRoot);
export const getEnableSave = compose(prop('enableSave'), getRoot);
